mutation AddTemplate($zipUrl: String!, $clientId: ID!, $campaignId: ID) {
    addMasterTemplate(temporaryBucketZipPath: $zipUrl, clientId: $clientId, campaignId: $campaignId) {
        previewMode
        masterTemplate {
            _id
            adType
            persistentKey
        }
        resource {
            resourceId
            status
            percentage
        }
    }
}
